export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-8 text-center">
      <div className="text-7xl font-bold text-muted-foreground/30 mb-4 select-none">404</div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">Page not found</h1>
      <p className="text-sm text-muted-foreground mb-8 max-w-sm">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="flex gap-3 flex-wrap justify-center">
        <a
          href="/"
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          Go Home
        </a>
        <a
          href="https://app.theonestack.com"
          className="px-4 py-2 border border-border rounded-md text-sm font-medium hover:bg-accent transition-colors"
        >
          Back to Hub
        </a>
      </div>
    </div>
  );
}
